export default {
        title: 'Herramientas de análisis espectral',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione los registros a eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		name: 'Nombre',
		placeholder: {
			name: 'Por favor ingrese el nombre'
		}
	},
	table: {
		id: 'ID',
                name: 'Nombre del tipo de espectro',
		toolCode: 'Código',
		icon: 'Icono',
		sort: 'Ordenar'
	},
	widgetForm: {
		id: 'ID',
                name: 'Nombre del tipo de espectro',
		toolCode: 'Código',
		icon: 'Icono',
		sort: 'Ordenar',
		remark: 'Observación',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			id: 'Por favor ingrese el ID',
                        name: 'Por favor ingrese el nombre del tipo de espectro',
			toolCode: 'Por favor ingrese el código',
			icon: 'Por favor seleccione el icono',
			sort: 'Por favor ingrese el orden',
			remark: 'Por favor ingrese la observación'
		}
	},
	dialog: {
		add: 'Añadir',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	}
}
